module.exports = __webpack_public_path__ + "static/media/3.504a9878.jpeg";